import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FooterAClasses from './FooterA.module.scss';
import FooterBClasses from './FooterB.module.scss';

const Footer = (props) => {
  const { imageLink = {}, listLinks = [], iconLinks = [], type = 'FooterB' } = props;

  const footerClasses = {
    FooterA: FooterAClasses,
    FooterB: FooterBClasses,
  };

  const classes = footerClasses[type];

  const image = (
    <img
      className={classes.image}
      src={imageLink.imageUrl}
      role='presentation'
      alt={imageLink.altText || imageLink.title || ''}
      width={imageLink.imageWidth}
      height={imageLink.imageHeight}
      loading='lazy'
    />
  );

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        {imageLink && (imageLink.href
          ? <a aria-label={imageLink.title} href={imageLink.href} target={imageLink.target}>{image}</a>
          : image
        )}
        {listLinks.length > 0 &&
          <ul className={classes.linkList}>
            {listLinks.map((link, index) => (
              <li key={`linkList-${index}`}>
                <a
                  aria-label={link.title}
                  href={link.href}
                  target={link.target}
                  dangerouslySetInnerHTML={{ __html: link.title }}
                />
              </li>
            ))}
          </ul>}
        {iconLinks.length > 0 &&
          <ul className={classes.iconsList}>
            {iconLinks.map((icon, index) => (
              <li className={classes.socialIcon} key={`iconsList-${index}`}>
                <a aria-label={icon.title} href={icon.href} target={icon.target}>
                  <span className={classNames(icon.icon, classes.socialIcon)} />
                </a>
              </li>
            ))}
          </ul>}
      </div>
    </div>
  );
};

Footer.propTypes = {
  imageLink: PropTypes.shape({
    title: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    imageUrl: PropTypes.string,
    altText: PropTypes.string,
    imageHeight: PropTypes.number,
    imageWidth: PropTypes.number,
  }),
  listLinks: PropTypes.array,
  iconLinks: PropTypes.array,
  type: PropTypes.string,
};

export default Footer;
